import { render, staticRenderFns } from "./lisaa-suoritteen-kategoria.vue?vue&type=template&id=677e1268&scoped=true&"
import script from "./lisaa-suoritteen-kategoria.vue?vue&type=script&lang=ts&"
export * from "./lisaa-suoritteen-kategoria.vue?vue&type=script&lang=ts&"
import style0 from "./lisaa-suoritteen-kategoria.vue?vue&type=style&index=0&id=677e1268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e1268",
  null
  
)

export default component.exports